const PAGE_SIZE_DEFAULT = 250;

export const pageSizeTypes = {
  PAGE_SIZE_DEFAULT,
};
